export const locale = {
    lang: 'en',
    data: {
        'PROGRESS': {
            'TITLE': 'Progress'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/progress/i18n/en.ts